import React, { useState } from 'react';
import GridServico from 'containers/ServicoListar/gridServicos';
import Filtro from 'containers/ServicoListar/filtro';
import TitlePage from 'components/TituloPage';
import { privateRoot } from 'routes/paths';
import * as S from './styles';
import * as Style from 'components/Style';

export default function PageListarServicos() {
  const [filtroSelecionado, setFiltroSelecionado] = useState({});

  return (
    <S.Page>
      <TitlePage textTitle={'Listar Serviços'} backPage={privateRoot} />
      <Filtro salvarFiltro={setFiltroSelecionado} />
      <S.ContainGrid>
        <Style.GlobalCard>
          <GridServico filtro={filtroSelecionado} />
        </Style.GlobalCard>
      </S.ContainGrid>
    </S.Page>
  );
}
